import { render, staticRenderFns } from "./CouncilCreation.vue?vue&type=template&id=cfc1c636&scoped=true"
import script from "./CouncilCreation.vue?vue&type=script&lang=js"
export * from "./CouncilCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc1c636",
  null
  
)

export default component.exports